export default "__VITE_ASSET__F6ouuEM5__"